import React from 'react';

export default function({ statementContent, className = '' }) {
  return (
    <div className={`${className} text-center`}>
      <p className="text-xl font-bold text-white">{ statementContent }</p>
    </div>
  );
}
